import React, { useMemo } from 'react';
import './style.scss';
import 'swiper/swiper.scss';
import 'swiper/modules/pagination/pagination.scss';
import { Swiper } from 'swiper/react/swiper-react.js';
import { Navigation, Pagination } from 'swiper';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { isServer } from '@sitecore-jss/sitecore-jss';

const CarouselSlider = ({
  children,
  onSlideSwap,
  spaceBetween = 8,
  slidesPerView = 1.5,
  className: externalClassName = 'carousel',
  style = undefined,
  bulletClassName = 'carousel-bullet',
  bulletActiveClassName = 'carousel-bullet-active',
  prevControlId,
  nextControlId,
  breakpoints = {},
  lang = 'en',
  hidePaginationOnMobiles = false,
}) => {
  const className = useMemo(() => {
    return clsx(externalClassName, hidePaginationOnMobiles && 'carousel-hide-mobile-padination');
  }, [externalClassName, hidePaginationOnMobiles]);

  const handleSwap = (swiper) => {
    if (!onSlideSwap) return;
    if (swiper?.pagination?.bullets?.length) {
      onSlideSwap(swiper.pagination.bullets.length, swiper.isBeginning, swiper.isEnd);
    } else {
      onSlideSwap(1, true, true);
    }
  };

  const handleLoad = (swiper) => {
    if (swiper?.pagination?.bullets?.length) {
      setTimeout(() => {
        swiper.slideTo(swiper?.pagination?.bullets?.length - 1);
      }, 300);
      setTimeout(() => {
        swiper.slideTo(0);
      }, 400);
    }
  };

  return (
    !isServer() && (
      <Swiper
        modules={[Pagination, Navigation]}
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        navigation={{
          prevEl:
            prevControlId && typeof document !== 'undefined'
              ? document.getElementById(prevControlId)
              : undefined,
          nextEl:
            nextControlId && typeof document !== 'undefined'
              ? document.getElementById(nextControlId)
              : undefined,
        }}
        onPaginationRender={handleSwap}
        onAfterInit={handleLoad}
        onSlideChange={handleSwap}
        pagination={{
          clickable: true,
          bulletClass: bulletClassName,
          bulletActiveClass: bulletActiveClassName,
        }}
        className={className}
        breakpoints={breakpoints}
        dir={lang === 'en' ? 'ltr' : 'rtl'}
        watchOverflow={true}
        style={style}
      >
        {children}
      </Swiper>
    )
  );
};

CarouselSlider.propTypes = {
  children: PropTypes.node,
  onSlideSwap: PropTypes.func,
  spaceBetween: PropTypes.number,
  slidesPerView: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  style: PropTypes.object,
  bulletClassName: PropTypes.string,
  bulletActiveClassName: PropTypes.string,
  prevControlId: PropTypes.string,
  nextControlId: PropTypes.string,
};

export default CarouselSlider;
